export default "__VITE_ASSET__odoBXfwn__"